module.exports = __webpack_public_path__ + "img/Banner-principal-2.d2c7586e.webp";